import * as e from "react";
import r from "../lib/IconBase.es.js";
import a from "../defs/Receipt.es.js";
const o = e.forwardRef((t, c) => /* @__PURE__ */ e.createElement(r, { ref: c, ...t, weights: a }));
o.displayName = "ReceiptIcon";
const p = o;
export {
  p as Receipt,
  o as ReceiptIcon
};
